import { useQuery } from 'react-query'

import { QueryKeys } from '../../../enums/queryKeys'
import { fetchInvoiceLateFee } from '../query-api'

export const useFetchInvoiceLateFee = (invoiceLateFeeId?: string) => {
  const { data, isLoading } = useQuery(
    [QueryKeys.InvoiceLateFee, invoiceLateFeeId],
    () => fetchInvoiceLateFee(invoiceLateFeeId as string),
    { enabled: !!invoiceLateFeeId },
  )

  return { invoiceLateFee: data?.invoiceLateFee, isLoading }
}
